// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"AddPokemon_mainContainer__1kbGh","labelsContainer":"AddPokemon_labelsContainer__1lMme","addButton":"AddPokemon_addButton__13m84"};